import { facebook } from 'assets/images/facebook-white.svg';
import Yup from 'utils/validation';
import { businessFormInitialValues } from '../utils';
import { isCEPEmpty, isCNPJEmpty, isValidCNPJ, validDDDs } from 'utils/basicUtils';

export const accomodationsInitialValues = {
  ...businessFormInitialValues,
  touristCorridor: '',
  accommodation: {
    id: '',
    category: '',
    description: '',
    numberOfBeds: '',
    numberOfRooms: '',
  },
};

export const accomodationsValidationSchema = Yup.object().shape({
  id: Yup.number().notRequired(),
  touristCorridor: Yup.string()
    .notRequired()
    .test(
      'not-only-spaces',
      'O corredor turístico não pode conter apenas espaços',
      value => !value || value.trim().length > 0
    ),
  businessOwner: Yup.array().of(
    Yup.string()
      .notRequired()
      .test(
        'not-only-spaces',
        'O nome do proprietário não pode conter apenas espaços',
        value => !value || value.trim().length > 0
      )
  ),
  businessRepresentative: Yup.string()
    .notRequired()
    .test(
      'not-only-spaces',
      'O nome do responsável comercial não pode conter apenas espaços',
      value => !value || value.trim().length > 0
    ),
  businessType: Yup.string()
    .notRequired()
    .test(
      'not-only-spaces',
      'O tipo de negócio não pode conter apenas espaços',
      value => !value || value.trim().length > 0
    ),
  description: Yup.string()
    .notRequired()
    .test('not-only-spaces', 'A descrição não pode conter apenas espaços', value => !value || value.trim().length > 0),
  document: Yup.string().notRequired(),
  googleMapsLink: Yup.string()
    .notRequired()
    .test(
      'not-only-spaces',
      'O link do Google Maps não pode conter apenas espaços',
      value => !value || value.trim().length > 0
    ),
  tradeName: Yup.string()
    .notRequired()
    .test(
      'not-only-spaces',
      'O nome fantasia não pode conter apenas espaços',
      value => !value || value.trim().length > 0
    ),
  title: Yup.string()
    .notRequired()
    .test('not-only-spaces', 'O título não pode conter apenas espaços', value => !value || value.trim().length > 0),
  phone: Yup.string().strict(true).notRequired(),
  site: Yup.string().notRequired(),
  youtubeLink: Yup.string().notRequired(),
  instagramLink: Yup.string().notRequired(),
  facebookLink: Yup.string().notRequired(),
  whatsapp: Yup.string(),
  image: Yup.array().notRequired(),
  address: Yup.object().shape({
    id: Yup.number(),
    city: Yup.string()
      .strict(true)
      .notRequired()
      .test('not-only-spaces', 'A cidade não pode conter apenas espaços', value => !value || value.trim().length > 0),
    neighborhood: Yup.string()
      .strict(true)
      .notRequired()
      .test(
        'not-only-numbers',
        'O bairro não pode conter somente números',
        value => !value || /^(?!^\d+$)[\d\D]*$/.test(value)
      )
      .test('not-only-spaces', 'O bairro não pode conter apenas espaços', value => !value || value.trim().length > 0),
    number: Yup.string().strict(true).notRequired(),
    state: Yup.string()
      .strict(true)
      .notRequired()
      .test('not-only-spaces', 'O estado não pode conter apenas espaços', value => !value || value.trim().length > 0),
    street: Yup.string()
      .strict(true)
      .notRequired()
      .test(
        'not-only-numbers',
        'O campo endereço não pode ser apenas números',
        value => !value || /^(?!\d+$).*/.test(value)
      )
      .test('not-only-spaces', 'O endereço não pode conter apenas espaços', value => !value || value.trim().length > 0),
    zipCode: Yup.string().strict(true).notRequired(),
  }),
  images: Yup.array().notRequired(),
  accommodation: Yup.object().shape({
    id: Yup.string().matches(/^\d+$/, 'O ID deve conter apenas dígitos'),
    category: Yup.string()
      .strict(true)
      .notRequired()
      .test(
        'not-only-spaces',
        'A categoria não pode conter apenas espaços',
        value => !value || value.trim().length > 0
      ),
    description: Yup.string(),
    numberOfBeds: Yup.string()
      .strict(true)
      .notRequired()
      .test('is-digits', 'O número de leitos deve conter apenas dígitos', value => !value || /^\d+$/.test(value)),
    numberOfRooms: Yup.string()
      .strict(true)
      .notRequired()
      .test('is-digits', 'O número de quartos deve conter apenas dígitos', value => !value || /^\d+$/.test(value)),
  }),
});
